module.exports = __webpack_public_path__ + "img/thumb3.76f85250.png";